import { animate, style, transition, trigger } from '@angular/animations';

export const skeletonTransitionAnimation = trigger('skeletonTransition', [
  transition(':enter', [style({ opacity: 0 }), animate('500ms 500ms', style({ opacity: 1 }))]),
  transition(':leave', [animate('500ms', style({ opacity: 0 }))])
]);
